package com.gsb.vyapar.bhagya.presentation.searchlist.util

import com.gsb.vyapar.bhagya.domain.Categories.D.Category
import com.gsb.vyapar.bhagya.domain.SubCategories.D.SubCategory
import com.gsb.vyapar.bhagya.domain.getCategoryId
import com.gsb.vyapar.bhagya.domain.getSubCategoryIds
import com.gsb.vyapar.bhagya.presentation.Screens
import com.gsb.vyapar.bhagya.presentation.business.uistate.getBusinessUiState
import com.gsb.vyapar.bhagya.presentation.navigation.util.pushView
import com.gsb.vyapar.bhagya.presentation.searchlist.uistate.getSearchListUiState

fun showSearchBusinessList(category: Category?, subCategory: SubCategory? = null) {
    var filteredList = getBusinessUiState().businessList.filter { it.getCategoryId() == category?.id.toString() }
    if (subCategory != null) filteredList = filteredList.filter { it.getSubCategoryIds().split(",").map { it.trim() }.contains(subCategory.id.toString()) }
    getSearchListUiState().updateSearchListTitleAndList(subCategory?.name ?: category?.name.orEmpty(), filteredList)
    pushView(Screens.SearchList)
}